module.exports = __webpack_public_path__ + "img/Pro Car Finance.d392f590.png";